import { reatomAsync, withDataAtom } from "@reatom/async";
import { API } from "src/api";
import { withIsLoadingAtom } from "src/common/pipes";

import { getPoizonClients } from "./getUserPoizonClients";

export const createPoizonClient = reatomAsync(() => {
  return API.poizonClientApi.clientControllerCreateClient({
    userAgentFilters: "" as unknown as object,
    sk: "" as unknown as object,
    duToken: "",
    xAuthToken: "",
  });
}, "createPoizonClient").pipe(withDataAtom(null), withIsLoadingAtom());

createPoizonClient.onFulfill.onCall((ctx) => {
  getPoizonClients(ctx);
});
